import { h } from "preact";
import { formatMoney } from "@helpers/currency";

interface MiniCartPriceProps {
  price: string | number;
  compareAtPrice: string | number;
}

function MiniCartPrice({ price, compareAtPrice }: MiniCartPriceProps) {
  return (
    <div className="minicart__price-wrapper">
      {Number(compareAtPrice) > Number(price) && (
        <div className="price__sale">
          <span className="visually-hidden">
            {window.themeVars.strings.product.price.sale}
          </span>

          <span
            className="
            price__item
            price__item--sale
            price__item--last
            text-md-body--semi-bold
          "
          >
            {formatMoney(price)}
          </span>

          <span className="visually-hidden">
            {window.themeVars.strings.product.price.sale}
          </span>

          <span>
            <span
              className="
              price__item
              price__item--regular
            "
            >
              {formatMoney(compareAtPrice)}
            </span>
          </span>
        </div>
      )}

      {Number(compareAtPrice) <= Number(price) && (
        <div className="price__regular">
          <span>
            <span className="visually-hidden">
              {window.themeVars.strings.product.price.regular}
            </span>

            <span
              className="
              price__item
              price__item--regular
              text-md-body--semi-bold
            "
            >
              {formatMoney(price)}
            </span>
          </span>
        </div>
      )}
    </div>
  );
}

export default MiniCartPrice;
